export default __webpack_public_path__ + "static/media/InsideStomach_10.21ea917e.png";